import React from 'react';
import { Pressable } from 'react-native';

import { Text } from '@/components/ui';
import { createStyles } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type ActionButtonProps = {
  label: string;
  variant: 'primary' | 'secondary';
  onPress: () => void;
};

export function ActionButton({ label, variant, onPress }: ActionButtonProps) {
  const styles = useStyles();
  const isPrimary = variant === 'primary';

  return (
    <Pressable
      accessibilityRole="button"
      onPress={onPress}
      style={({ pressed }) => [
        styles.actionButton,
        isPrimary ? styles.primaryButton : styles.secondaryButton,
        pressed && styles.pressed,
      ]}>
      <Text
        variant="Font Guardian App/Subtitle/Subtitle 14 Semibold"
        numberOfLines={1}
        style={isPrimary ? styles.primaryButtonText : styles.secondaryButtonText}>
        {label}
      </Text>
    </Pressable>
  );
}

const useStyles = createStyles(({ scale }) => ({
  actionButton: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: scale(12),
    borderCurve: 'continuous',
    height: scale(40),
    flex: 1,
    paddingHorizontal: scale(10),
  },
  primaryButton: {
    backgroundColor: guardianColors['Main/Main'],
  },
  secondaryButton: {
    backgroundColor: guardianColors['Main/10'],
  },
  primaryButtonText: {
    color: colors['0'],
    textAlign: 'center',
  },
  secondaryButtonText: {
    color: guardianColors['Main/Main'],
    textAlign: 'center',
  },
  pressed: {
    opacity: 0.82,
  },
}));
